
import brLang from './entries/pt-BR';
import {addLocaleData} from 'react-intl';

const AppLocale = {
    br: brLang,
};
addLocaleData(AppLocale.br.data);

export default AppLocale;
